var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.features, function (feature, index) {
      return _c(
        "div",
        { key: `layer-featureable-feature-${index}`, staticClass: "card" },
        [
          _c("img", {
            staticClass: "card-img-top",
            attrs: { src: _vm.featureImage(feature), alt: "image feature" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("h5", { staticClass: "card-title" }, [
              _vm._v(_vm._s(_vm.featureName(feature))),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "card-text" }, [
              _vm._v(_vm._s(_vm.featureDescription(feature))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-footer" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center text-muted",
                  },
                  [
                    _vm.entityImage
                      ? _c("img", {
                          staticClass: "img-thumbnail",
                          attrs: {
                            src: _vm.entityImage,
                            loading: "lazy",
                            alt: "...",
                          },
                        })
                      : _vm._e(),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.entityName) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "btn btn-secondary-main d-flex align-items-center",
                    attrs: {
                      href: "#",
                      "data-toggle": "tooltip-city",
                      title: _vm.$t(`${_vm.translateID}.actions.select`),
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onSelect(feature)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "code" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.featureCode(feature)) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "fas fa-right-long" }),
                  ]
                ),
              ]
            ),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }